import React, { useMemo, useState } from "react";
import { useGetTopics } from "../../api/queries";
import { CategoryEnum, ModuleStatus } from "../../types";
import FilterChipGroup from "../../componentLibrary/FilterChipGroup";
import Spinner from "../../componentLibrary/Spinner";
import { ErrorDisplay } from "../../utils/ErrorHandling";
import TopicCard from "../ExplorePage/components/TopicCard";

const allCategories = Object.values(CategoryEnum);
const allStatuses = Object.values(ModuleStatus);

const DraftTopicsList = () => {
  const [selectedCategory, setSelectedCategory] = useState<CategoryEnum | null>(
    null,
  );
  const [statusFilter, setStatusFilter] = useState<ModuleStatus | null>(null);

  const { data: topics, isError, isLoading, error } = useGetTopics();

  const filteredTopics = useMemo(() => {
    if (!topics) return [];
    return topics
      .filter((topic) =>
        selectedCategory ? topic.categories.includes(selectedCategory) : true,
      )
      .filter((topic) => (statusFilter ? topic.status === statusFilter : true))
      .sort((a, b) => a.title.localeCompare(b.title));
  }, [topics, selectedCategory, statusFilter]);

  if (isLoading) return <Spinner className="mx-auto" />;
  if (isError) return <ErrorDisplay error={error} messageSource="api" />;

  return (
    <div className="w-full">
      <section className="mb-5">
        <h3 className="mb-2">Status</h3>
        <div className="flex flex-wrap gap-2">
          <FilterChipGroup
            options={allStatuses}
            selectedOption={statusFilter}
            onChange={(option) =>
              setStatusFilter(option as ModuleStatus | null)
            }
          />
        </div>
      </section>

      <section className="mb-5">
        <h3 className="mb-2">Category</h3>
        <div className="flex flex-wrap gap-2">
          <FilterChipGroup
            options={allCategories}
            selectedOption={selectedCategory}
            onChange={(option) =>
              setSelectedCategory(option as CategoryEnum | null)
            }
          />
        </div>
      </section>

      {filteredTopics.length === 0 ? (
        <p className="text-electrum py-8 text-center">
          No modules match these filters.
        </p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 pb-6">
          {filteredTopics.map((topic) => (
            <TopicCard key={topic._id} module={topic} showStatusIndicator />
          ))}
        </div>
      )}
    </div>
  );
};

export default DraftTopicsList;
